export default {
  favorites: [],
  lessons: [],
  count: 0
};
